export default "__VITE_ASSET__RkIHa3EA__"